// Etapa 4 (punto 13 de propuesta_frontend_offline.md): totales del cierre de caja con las ventas de esa caja
// que siguen en la cola local. Función pura: no toca los totales del servidor, devuelve una copia ajustada.
// Montos de cada venta, del payload guardado (mismas reglas que ProcesarVentaService::registrarPagoClientesDetallePagos
// con tipo_pago_id = 1, que el POS manda siempre):
//   total = total_cancelar · efectivo = total_cancelar − monto_pago · otro método = monto_pago en metodo_pago_id
// No se usa payload.efectivo: es lo que entregó el cliente y puede incluir el cambio.

const r2 = (n) => Math.round((Number(n) || 0) * 100) / 100;

const EFECTIVO = 1;

// Resumen de las ventas pendientes (para los textos «incluye r ventas sin enviar (Bs x)»)
export function resumenPendientes(ventasPendientes) {
  const res = { cantidad: 0, total: 0, efectivo: 0, metodos: 0 };
  for (const v of ventasPendientes || []) {
    const p = (v && v.payload) || v || {};
    const total = Number(p.total_cancelar) || 0;
    const montoPago = Number(p.monto_pago) || 0;
    res.cantidad += 1;
    res.total = r2(res.total + total);
    res.efectivo = r2(res.efectivo + (total - montoPago));
    res.metodos = r2(res.metodos + montoPago);
  }
  return res;
}

// totalesServidor: los calculo_* de GET /caja (o /caja/{id}) y detalle_suma_cobros_x_metodos_pago.
// ventasPendientes: filas de cola_ventas (o sus payload) con estado pendiente/enviando de ESA caja.
// metodosPago: [{ id, nombre }] para nombrar una fila nueva del detalle (si no está: «Método N»).
export function sumarVentasPendientes(totalesServidor, ventasPendientes, metodosPago = []) {
  const t = totalesServidor || {};
  const detalle = (Array.isArray(t.detalle_suma_cobros_x_metodos_pago) ? t.detalle_suma_cobros_x_metodos_pago : [])
    .map((f) => ({ ...f, total: r2(f.total) }));
  const res = {
    calculo_total_ventas: r2(t.calculo_total_ventas),
    calculo_total_saldo_caja: r2(t.calculo_total_saldo_caja),
    calculo_total_ventas_metodos_pago: r2(t.calculo_total_ventas_metodos_pago),
    detalle_suma_cobros_x_metodos_pago: detalle,
  };
  for (const v of ventasPendientes || []) {
    const p = (v && v.payload) || v || {};
    const total = Number(p.total_cancelar) || 0;
    const montoPago = Number(p.monto_pago) || 0;
    const metodo = Number(p.metodo_pago_id) || EFECTIVO;
    res.calculo_total_ventas = r2(res.calculo_total_ventas + total);
    res.calculo_total_saldo_caja = r2(res.calculo_total_saldo_caja + (total - montoPago));
    res.calculo_total_ventas_metodos_pago = r2(res.calculo_total_ventas_metodos_pago + montoPago);
    // El detalle del servidor excluye el método 1 (efectivo): igual aquí
    if (montoPago > 0 && metodo !== EFECTIVO) {
      let fila = detalle.find((f) => Number(f.metodo_pago_id) === metodo);
      if (!fila) {
        const m = (metodosPago || []).find((x) => Number(x.id) === metodo);
        fila = { metodo_pago_id: metodo, nombre: (m && m.nombre) || `Método ${metodo}`, total: 0 };
        detalle.push(fila);
      }
      fila.total = r2(fila.total + montoPago);
    }
  }
  return res;
}
